import gql from 'graphql-tag';

export const GET_ACCESS_POINT_MIGRATION_STATUS = gql`
  query InternalAccessPointMigrationStatus($isStaging: Boolean) {
    internalAccessPointMigrationStatus(isStaging: $isStaging) {
      totalLinkedDatasets
      migratedCount
      unmigratedCount
      missingDropPointCount
      failedCount
      differingCount
      openingHoursDifferingCount
      identityDifferingCount
      isStaging
      scope
    }
  }
`;

export const RUN_ACCESS_POINT_MIGRATION = gql`
  mutation InternalMigrateAccessPointDataToStations($dryRun: Boolean, $force: Boolean, $limit: Int, $isStaging: Boolean) {
    internalMigrateAccessPointDataToStations(dryRun: $dryRun, force: $force, limit: $limit, isStaging: $isStaging) {
      processed
      migrated
      skippedAlreadyMigrated
      missingDropPoint
      failed
      differing
      dryRun
      force
      isStaging
      scope
      failures {
        accessPointId
        packageStationId
        reason
      }
    }
  }
`;

export type AccessPointMigrationStatus = {
  totalLinkedDatasets: number;
  migratedCount: number;
  unmigratedCount: number;
  missingDropPointCount: number;
  failedCount: number | null;
  differingCount: number;
  openingHoursDifferingCount: number;
  identityDifferingCount: number;
  isStaging: boolean | null;
  scope: string;
};

export type AccessPointMigrationResult = {
  processed: number;
  migrated: number;
  skippedAlreadyMigrated: number;
  missingDropPoint: number;
  failed: number;
  differing: number;
  dryRun: boolean;
  force: boolean;
  isStaging: boolean | null;
  scope: string;
  failures: {
    accessPointId: string;
    packageStationId?: string | null;
    reason: string;
  }[];
};

export type AccessPointMigrationStatusQuery = {
  internalAccessPointMigrationStatus: AccessPointMigrationStatus;
};

export type AccessPointMigrationStatusVariables = {
  isStaging?: boolean;
};

export type AccessPointMigrationMutation = {
  internalMigrateAccessPointDataToStations: AccessPointMigrationResult;
};

export type AccessPointMigrationVariables = {
  dryRun?: boolean;
  force?: boolean;
  limit?: number;
  isStaging?: boolean;
};
